import React, { useState, useEffect,useRef } from "react";
import axios from "axios";
import { APILINK } from "../EndPoint";
import ErrorHandler from "../error-handler/ErrorHandler";
import {
  Container,
  Row,
  Col,
  Tooltip,
  OverlayTrigger,
  Modal,
} from "react-bootstrap";

import { Button } from "antd";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Pagination, Spin } from "antd";
import DataTable from "react-data-table-component";
import { Input } from "antd";

const { TextArea } = Input;
const axiosApiInstance = axios.create();
const UnverifiedUsers = (props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState("1");
  const [current, setCurrent] = useState("1");
  const [data, setData] = useState([]);
  const [columns, setCoulmns] = useState([
    {
      name: `${t("unverifiedTable.name")}`,
      selector: "user.username",
      sortable: true,
      right: true,
    },
    {
      name: `${t("unverifiedTable.email")}`,
      selector: "user.email",
      sortable: true,
      right: true,
    },
    {
      name: `${t("unverifiedTable.actions")}`,
      button: true,
      cell: (row) => (
        <div className="table-data-feature">
          <OverlayTrigger
            key={"4"}
            placement={"top"}
            overlay={<Tooltip id={`tooltip-${"top"}`}>Verify User</Tooltip>}
          >
            <i
              id={row.id}
              onClick={showModel}
              className="fas fa-user-check pr-2 icons"
            ></i>
          </OverlayTrigger>
        </div>
      ),
    },
  ]);
  const [show, setShow] = useState(false);
  const [userID, setID] = useState("");
  const [reason, setReason] = useState("");
  const [showRejection, setRejection] = useState(false);
  const rejectRef = useRef();

  const getData = async () => {
    let result = await axiosApiInstance.get(
      APILINK + `/create_bank_user?page=1`
    );
    setData(result.data.data);
    setCount(result.data.count);
    setLoading(false);
  };
  useEffect(() => {
    setLoading(true);

    getData();
  }, []);

  const onChange = (page) => {
    console.log(page);
    this.setState(
      {
        current: page,
      },
      async () => {
        let result = await axiosApiInstance.get(
          APILINK + `/create_bank_user?page=${this.state.current}`
        );
        setData(result.data.data);
        setCount(result.data.count);
      }
    );
  };
  const showModel = (e) => {
    setShow(true);
    setID(e.target.id);
  };
  const close = (e) => {
    setShow(false);
  };
  const verify = async () => {
    let data = {
      verdict: true,
    };
    let result = await axiosApiInstance.post(
      APILINK + `/check_user/${userID}`,
      data
    );
    console.log(result);
    if (result) {
      setTimeout(() => {
        toast.info(t("success"));
      }, 500);
      setShow(false);
      getData();
    }
  };
  const reject = async () => {
    let data;
    if (reason !== "") {
      data = {
        verdict: false,
        rejection_reason: reason,
      };
    } else {
      data = {
        verdict: false,
      };
    }

    let result = await axiosApiInstance.post(
      APILINK + `/check_user/${userID}`,
      data
    );
    console.log(result);
    if (result) {
      setTimeout(() => {
        toast.info(t("success"));
      }, 500);
      setShow(false);
      getData();
      setRejection(false);
    }
  };
  const showRejectionModel = (e) => {
    setRejection(true);
  };
  const closeRejection = (e) => {
    setRejection(false);
  };
  return (
    <Container
      style={{
        textAlign: localStorage.getItem("lang") == "ar" ? "right" : "left",
      }}
      className="viewSuper align-left"
    >
      <Row>
        <Col sm="12">
          <h4 className="title">{t("unverified")}</h4>
        </Col>
      </Row>
      {loading ? (
        <Spin className="spinElement" tip="..loading" />
      ) : (
        <>
          <Row>
            <Col style={{ textAlign: "center" }} sm={12}>
              <DataTable columns={columns} data={data} />
            </Col>
          </Row>
          <Row className="p-4">
            {data.length !== 0 ? (
              <Pagination
                onChange={onChange}
                defaultCurrent={current}
                total={count}
                current={current}
              />
            ) : null}
          </Row>
        </>
      )}
      <ToastContainer position="bottom-right" />
      <Modal show={show} onHide={close}>
        <Container className="p-4">
          <Row>
            <Col className="text-center" sm={12}>
              {" "}
              <h6>{t("unverifiedTable.msg")}</h6>
            </Col>
          </Row>
          <Row style={{ margin: "auto" }}>
            <Col className="text-center" md={12}>
              <button  onClick={verify} className="acceptBtn mx-3">
                {t("unverifiedTable.confirm")}
              </button>
              <button className="rejectBtn" onClick={showRejectionModel}>
                {t("unverifiedTable.reject")}
              </button>
            </Col>
          </Row>
        </Container>
      </Modal>
      <Modal show={showRejection} onHide={closeRejection}>
        <Container className="p-4">
          <Row>
            <Col className="text-center" sm={12}>
              {" "}
              <h6 style={{ fontWeight: "600" }}>
                {t("unverifiedTable.rejectionHead")}
              </h6>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col className="text-center" sm="12">
              <textarea
                ref={rejectRef}
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value);
                }}
                placeholder={t("unverifiedTable.reason")}
                className="w-100"
                row="3"
              />
              <button className="rejectBtn mx-3" onClick={reject}>
                {t("unverifiedTable.submitReject")}
              </button>{" "}
              <button className="cancelBtn" onClick={closeRejection}>
                {t("unverifiedTable.cancel")}
              </button>
            </Col>
          </Row>
        </Container>
      </Modal>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(
  mapStateToProps,
  null
)(ErrorHandler(UnverifiedUsers, axiosApiInstance));
